import React from 'react';

import Seo from '../components/seo/Seo';
import AboutHero from '../components/about/AboutHero';
import AboutStory from '../components/about/AboutStory';
import AboutVisionMissionValues from '../components/about/AboutVisionMissionValues';
import AboutStrategicApproach from '../components/about/AboutStrategicApproach';
import HomeFaqNewsletter from '../components/home/HomeFaqNewsletter';

export default function About(): React.ReactElement {
  return (
    <>
      <Seo
        title="About Us - Ancient Engineering | Zimbabwe Engineering Company"
        description="Learn about Ancient Engineering's mission, values, and commitment to engineering excellence in Zimbabwe. Founded on entrepreneurship and excellence, serving Mining, Construction, and Manufacturing sectors."
        keywords="about Ancient Engineering, engineering company Zimbabwe, Zimbabwe engineering firm, industrial engineering Zimbabwe"
        ogTitle="About Us - Ancient Engineering"
        ogDescription="Learn about Ancient Engineering's mission, values, and commitment to engineering excellence in Zimbabwe."
        canonical="https://www.ancientengineering.co.zw/about"
      />
      <AboutHero />
      <AboutStory />
      <AboutVisionMissionValues />
      <AboutStrategicApproach />
      <HomeFaqNewsletter />
      {/* Add more about page sections here */}
    </>
  );
}

